import React from 'react';
import useAssetImport from '../../../hooks/useAssetImport';

interface GlobalHeaderProps {
  customerContext?: any;
  userContext?: any;
  breadCrumbList?: any;
  title?: string;
  type?: string;
}

export const GlobalHeader: React.FC<GlobalHeaderProps> = ({
  customerContext,
  userContext,
  breadCrumbList,
  title,
  type
}) => {
  const { asset, isLoading } = useAssetImport('@mssi/react-mps-header');

  const HeaderMFE = asset?.['default'];

  const assetIsNotReactComponent =
    !isLoading && typeof HeaderMFE !== 'function';

  return (
    <div>
      {!assetIsNotReactComponent && HeaderMFE && (
        <HeaderMFE
          customerContext={customerContext}
          userContext={userContext}
          breadCrumbList={breadCrumbList}
          title={title}
          type={type}
        />
      )}
    </div>
  );
};

export default GlobalHeader;
